import { create } from 'zustand';

export type CanvasVersionTargetLink = {
  canvasId: string;
  clipId: string;
  /** Runs started on the asset or on a result made from it, so those results stay saveable as new versions. */
  runIds: string[];
};

type CanvasVersionTargetSessionState = {
  link: CanvasVersionTargetLink | null;
  setLink: (link: CanvasVersionTargetLink | null) => void;
};

/**
 * The asset a canvas was opened from, for this page load only. A reload drops it, leaving the canvas in the app
 * clears it (`useClearCanvasVersionTargetOnLeave`), and a copied canvas URL never carries it.
 */
export const useCanvasVersionTargetSessionStore = create<CanvasVersionTargetSessionState>()((set) => ({
  link: null,
  setLink: (link) => set({ link }),
}));
